import type { FlexyAlmacenesQuery } from '../types/flexyAlmacenes'

/** Listado de almacenes Flexy. baseURL de axios ya incluye /api. */
export const FLEXY_ALMACENES_PATH = '/flexy/almacenes'

export function buildFlexyAlmacenesPath(query: FlexyAlmacenesQuery = {}): string {
  const params = new URLSearchParams()

  if (query.idempresa != null) {
    params.set('idempresa', String(query.idempresa))
  }
  if (query.activo) {
    params.set('activo', query.activo)
  }

  const search = params.toString()
  return search ? `${FLEXY_ALMACENES_PATH}?${search}` : FLEXY_ALMACENES_PATH
}
